import React, { PropsWithChildren } from 'react';
import { BaseProps, RefOrUndefined } from './Types';

function constructIcon(
  { className = '', ...props }: PropsWithChildren<BaseProps<HTMLSpanElement>>,
  ref: RefOrUndefined<HTMLSpanElement>
) {
  return (
    <span {...props} ref={ref} className={'material-icons ' + className} />
  );
}

export const Icon = React.forwardRef(constructIcon);
